var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4762 23.961C21.9219 23.961 24.1001 21.7828 24.1001 16.3371V9.80224C24.1001 4.35656 21.9219 2.17828 16.4762 2.17828H9.94134C4.49566 2.17828 2.31738 4.35656 2.31738 9.80224V16.3371C2.31738 21.7828 4.49566 23.961 9.94134 23.961H16.4762Z",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1988 17.9707V8.16851C19.1988 6.97046 18.2186 5.99023 17.0206 5.99023C15.8225 5.99023 14.8423 6.97046 14.8423 8.16851V17.9707C14.8423 19.1688 15.8116 20.149 17.0206 20.149C18.2186 20.149 19.1988 19.1688 19.1988 17.9707Z",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5753 17.9708V14.1588C11.5753 12.9608 10.5951 11.9805 9.39702 11.9805C8.19897 11.9805 7.21875 12.9608 7.21875 14.1588V17.9708C7.21875 19.1688 8.18808 20.1491 9.39702 20.1491C10.5951 20.1491 11.5753 19.1688 11.5753 17.9708Z",
    stroke: "#9C9EA6",
    strokeWidth: 1.63371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.546fe585.svg";
export { ForwardRef as ReactComponent };